import React, { Fragment } from 'preact/compat';
import { Field } from 'formik';
import { ProductOptions } from './types';
import { useSelfServiceFormContext } from './context';
import { getSingleProductOption, isSingleProductOption } from './products';

export function ProductField(props: ProductFieldProps) {
    const { products } = useSelfServiceFormContext();

    if (isSingleProductOption(products)) {
        const [id, name] = getSingleProductOption(products);

        return (
            <Field as='select' disabled={true} className='input  input--select' {...props}>
                <option value={id}>{name}</option>
            </Field>
        );
    }

    return (
        <Field as='select' className='input  input--select' {...props}>
            <option />
            <ProductMenuOptions options={products} />
        </Field>
    );
}

type ProductFieldProps = {
    name: string,
    id: string,
};

export function ProductMenuOptions({ options }: ProductMenuOptionsProps) {
    return (
        <Fragment>
            {Object.entries(options).map(([key, value]) => {
                if (typeof value === 'string') {
                    return (
                        <option key={key} value={key}>{value}</option>
                    );
                }

                return (
                    <optgroup key={key} label={key}>
                        <ProductMenuOptions options={value} />
                    </optgroup>
                );
            })}
        </Fragment>
    );
}

type ProductMenuOptionsProps = {
    options: ProductOptions,
}
